import { createCardNews } from '@lc/interface/card/news/factory';

export const NewsMeta = [
	createCardNews(
		0,
		`OIL SPILL CULLS INVASIVE BABY OTTER POPULATION`,
		`TAKE THREE (3) CARBON FROM THE CENTRAL POOL AND PLACE IT INTO THE CARBON RESERVE OF THE PLAYER WHO IS GOING LAST THIS MONTH. **IF THE CARBON WOULD RUN OUT, EVERY PLAYER LOSES A FACTORY INSTEAD**`,
		`“THEY DESERVED IT."`
	),
	createCardNews(
		1,
		`“ART OF THE STEAL” REACHES NUMBER ONE ON BEST SELLER LIST`,
		`EVERY PLAYER TAKES ONE (1) CARBON FROM THE CENTRAL CARBON POOL AND PLACES IT INTO THEIR FOOTPRINT **IF CARBON WOULD RUN OUT, ALL PLAYERS MUST PUT TWO (2) ENERGY INTO THEIR DONATION CUP INSTEAD**`,
		`“AS LONG AS YOU’RE GOING TO BE STEALING ANYWAY, STEAL BIG.”`
	),
	createCardNews(
		2,
		`CONGRESSMAN DENIES CLIMATE CHANGE EVEN THOUGH HIS BEACH HOUSE IS UNDERWATER`,
		`EACH PLAYER RECHARGES ALL BATTERIES MINUS THE AMOUNT OF CARBON IN THEIR FOOTPRINT (I.E. IF A PLAYER HAS THREE (3) BATTERIES AND TWO (2) CARBON IN THEIR FOOTPRINT, THEY CHARGE ONE (1) BATTERY)`,
		`“NOW IT DOUBLES AS AN OFFSHORE TAX HAVEN.”`
	),
	createCardNews(
		3,
		`“NANNY STATE” STRIKES AGAIN`,
		`PLAYER(S) WITH THE FEWEST FACTORIES MAY BUY ONE (1) FACTORY FOR HALF OFF ROUNDED DOWN **ONE PLAYER MUST HAVE AT LEAST ONE (1) MORE FACTORY THAN ANOTHER**`,
		`“SODA TAX?! WHAT’S NEXT, MY INCOME?”`
	),
	createCardNews(
		4,
		`SUPER PAC LEGALLY PROCLAIMED A PERSON`,
		`EVERY PLAYER WITH CARBON IN THEIR FOOTPRINT LOSES ONE (1) PR IF YOU HAVE NO PR (BEFORE THIS CARD WAS DRAWN) LOSE A BATTERY`,
		`“I’M ONLY HUMAN.”`
	),
	createCardNews(
		5,
		`OIL SHIPMENT THIEVES BROUGHT TO JUSTICE IN MIDDLE EAST`,
		`PLAYER(S) WITH CARBON FOOTPRINTS FOUR (4) OR GREATER DISCARD THEIR HANDS IF THEY HAVE NO HAND TO DISCARD, LOSE A FACTORY`,
		`“THIEVERY THESE DAYS COSTS AN ARM AND A LEG.”`
	),
	createCardNews(
		6,
		`ELECTRIC CAR FOUND IN MIDDLE OF 1928`,
		`EACH PLAYER LOSES ONE (1) PR PER CARBON IN THEIR FOOTPRINT. IF A PLAYER’S PR WOULD GO BELOW ZERO, DISCARD A BATTERY PER NEGATIVE PR`,
		`“NOWADAYS WE JUST LOBBY CONGRESS.”`
	),
	createCardNews(
		7,
		`NO NEWS IS GOOD NEWS`,
		``,
		`“NOTHING TO SEE HERE, FOLKS.”`
	),
	createCardNews(
		8,
		`STUDIES SHOW THERE IS SUCH A THING AS BAD PUBLICITY`,
		`FACTORIES ONLY PRODUCE ENERGY THIS MONTH UP TO THE AMOUNT OF PR YOU HAVE (I.E. IF YOU HAVE TWO (2) PR, ONLY TWO (2) FACTORIES PRODUCE ENERGY THIS MONTH)`,
		`“NEXT TIME, CLEAR YOUR BROWSER HISTORY.”`
	),
	createCardNews(
		9,
		`IN SOVIET RUSSIA CONTRACT ACCEPT YOU`,
		`PLAYER(S) WITH THE LOWEST PR MUST ACCEPT A CONTRACT OR DONATE ALL ENERGY PRODUCED BY FACTORIES TO THEIR DONATION CUP **THERE MUST BE AT LEAST ONE PLAYER WITH AT LEAST ONE (1) PR**`,
		`“DA.”`
	),
	createCardNews(
		10,
		`CIVILIZATION OFFICIALLY MOVES INTO MISINFORMATION AGE`,
		`PLAYER(S) WITH THE LOWEST PR MAY TAKE ONE (1) PR FROM EACH NEIGHBORING PLAYER **THERE MUST BE AT LEAST ONE PLAYER WITH ONE (1) PR**`,
		`“ALTERNATIVE FACTS.”`
	),
	createCardNews(
		11,
		`GLACIER NATIONAL PARK REBRANDS AS A WATER PARK`,
		`EACH PLAYER’S FACTORIES PRODUCE THE COLOR ENERGY OF THE PLAYER TO THEIR RIGHT`,
		`“YELLOWSTONE NATIONAL SPA OPENING SOON.”`
	),
	createCardNews(
		12,
		`GREAT LAKES RENAMED GREAT LANDFILLS`,
		`PLAYER(S) WITH THE LOWEST PR TAKE ONE (1) CARBON FROM EACH NEIGHBOR’S FOOTPRINT AND PLACES IT INTO THEIR OWN FOOTPRINT`,
		`“GREAT WORK.”`
	),
	createCardNews(
		13,
		`LOCAL FRACKING TURNS SUPER-SOAKER INTO FLAMETHROWER`,
		`PLAYER(S) WITH THE LOWEST PR LOSES A BATTERY. PLAYER(S) WITH THE HIGHEST CARBON FOOTPRINT LOSES A BATTERY IF A PLAYER IS BOTH, THEY LOSE A FACTORY INSTEAD`,
		`“THE SPRINKLER SYSTEM DIDN’T HELP.”`
	),
	createCardNews(
		14,
		`CLIMATE SCIENTIST CALLED “NERD” AT SENATE HEARING`,
		`PLAYER(S) WITH THE HIGHEST PR MAY DISTRIBUTE TWO (2) CARBONS FROM THEIR FOOTPRINT TO THEIR NEIGHBORS’ FOOTPRINTS OR CHARGE THREE (3) BATTERIES`,
		`“WHY SHOULD WE CARE IF THIS IS PEER REVIEWED? ALL YOUR FRIENDS ARE LOSERS.”`
	),
	createCardNews(
		15,
		`WIDELY AGREED UPON AND PEER-REVIEWED RESEARCH GETS PUBLISHED`,
		`EVERYBODY GETS A FREE CHARGED BATTERY!`,
		`“HEY THIS ISN’T NEWS! I WONDER WHAT THE KARDASHIANS ARE UP TO?”`
	),
	createCardNews(
		16,
		`GENDER REVEAL PARTY ACCIDENT KILLS BELOVED BEAR MASCOT`,
		`PLAYER(S) WITH HIGHEST PR MAY RECHARGE ALL BATTERIES MUST HAVE PR OF AT LEAST ONE (1)`,
		`“CHILDREN ACROSS THE NATION IN DENIAL. IT’S IMPAWSIBLE , THEY SAY.”`
	),
	createCardNews(
		17,
		`ENERGY COMPANY LEAKS EVERY CUSTOMERS’ PRIVATE INFORMATION`,
		`PLAYER(S) WITH THE LOWEST PR CHOOSE ONE OF THEIR CONTRACTS IN FRONT OF THEM. THEY AUTOMATICALLY FAIL IT AT THE NEXT SUMMIT. IF NO CONTRACTS ARE IN FRONT OF THEM THEY DO NOT PRODUCE ENERGY THIS MONTH.`,
		`“COMPANY APOLOGIZED BY DOING NOTHING.”`
	),
	createCardNews(
		18,
		`MAINSTREAM ACTRESS DECLARES RENEWABLE ENERGY CAUSES GLUTEN INTOLERANCE`,
		`PLAYER(S) WHOSE PR AMOUNT IS LESS THAN FOUR (4) PRODUCE TWO (2) LESS ENERGY THIS TURN`,
		`“LET THEM EAT (GLUTEN-FREE) CAKE!”`
	),
	createCardNews(
		19,
		`NIKOLA TESLA’S GHOST SPOTTED ATTEMPTING TO SEDUCE A POWER LINE`,
		`EVERYONE RECHARGES ALL BATTERIES!`,
		`“WHO YOU GONNA CALL?”`
	),
	createCardNews(
		20,
		`WINTER OLYMPICS CUT SHORT BY LAST SNOWFLAKE MELTING`,
		`OUTSTANDING AWARD CARD WINNERS ARE DECIDED NOW`,
		`“I LIKE THE SUMMER OLYMPICS BETTER ANYWAY.”`
	),
	createCardNews(
		21,
		`DADS AGAINST ELECTRIC CARS`,
		`TURN ORDER IS REVERSED FOR THIS MONTH THE PLAYER WHO WOULD GO LAST NOW GOES FIRST, AND THE PLAYER WHO WOULD GO SECOND TO LAST GOES SECOND, ETC.`,
		`“DAD’S NOT HAPPY TODAY.”`
	),
	createCardNews(
		22,
		`CLEAN AIR ADDED TO ENDANGERED SPECIES LIST`,
		`THE COST OF PR THIS MONTH IS ONE (1) ENERGY FOR PLAYER(S) WHO ALREADY HAVE PR. PLAYER(S) WHO HAVE ZERO (0) PR TAKE A CARBON FROM THE CARBON POOL AND PUT IN INTO THEIR FOOTPRINT`,
		`“RIGHT BETWEEN PANDAS AND HONEST POLITICIANS.`
	),
	createCardNews(
		23,
		`ENERGY COMPANY FOUND SUPPLEMENTING GEOTHERMAL PLANT WITH TIRE FIRE`,
		`PLAYER(S) WITH THE HIGHEST CARBON FOOTPRINT LOSES TWO (2) PR PLAYER(S) WITH THE SECOND HIGHEST CARBON FOOTPRINT LOSES ONE (1) PR **IF A PLAYER DOES NOT HAVE ANY PR TO LOSE, THEY DISCARD A BATTERY INSTEAD**`,
		`“IT WAS LIKE THAT WHEN WE GOT HERE.”`
	),
	createCardNews(
		24,
		`SPIN CLASSES USED TO POWER THE GRID`,
		`IF THERE ARE LESS THAN TEN (10) CARBON IN THE CENTRAL POOL, EVERYONE HAS TO CONTRIBUTE ALL ENERGY PRODUCED BY FACTORIES THIS MONTH`,
		`“STUDIES SHOW THIS IS MOST EFFECTIVE IN THE FIRST WEEK OF JANUARY.”`
	),
	createCardNews(
		25,
		`PRO-TOBACCO SCIENTIST SAYS JURY STILL OUT ON CLIMATE CHANGE`,
		`PLAYER(S) WITH HIGHEST PR GAIN ONE (1) BATTERY AND RECHARGE ALL BATTERIES`,
		`“WE JUST DON’T HAVE ALL THE FACTS YET.”`
	),
	createCardNews(
		26,
		`CHILDREN FREED FROM CRYPTOCURRENCY MINE`,
		`PLAYER(S) WITH LARGEST CARBON FOOTPRINT HAVE AN ENERGY STOLEN BY EACH NEIGHBOR`,
		`“FREEDOM FOUND FOR MINOR MINERS.”`
	),
	createCardNews(
		27,
		`CLIMATE CHANGE DENIER USES LEECHES TO FIGHT COMMON COLD`,
		`IF YOU HAVE A CHARGED BATTERY PUT ALL STORED ENERGY INTO YOUR CUP THEN RECHARGE ALL YOUR BATTERIES`,
		`“YOU KNOW WHAT WE CALL ALTERNATIVE MEDICINE THAT WORKS? MEDICINE.”`
	),
	createCardNews(
		28,
		`NASA RECLASSIFIES EARTH AS A GAS GIANT`,
		`PLAYER(S) WITH THE LEAST PR MUST TAKE TWO (2) CARBON FROM THE CARBON POOL AND PLACE IT DIRECTLY INTO THEIR CARBON FOOTPRINT **IF THE CARBON WOULD RUN OUT, EVERY PLAYER LOSES A FACTORY INSTEAD**`,
		`“ALONG WITH YOUR MOM.”`
	),
	createCardNews(
		29,
		`CELEBRITY WEARS OUTFIT ENTIRELY MADE OF E-WASTE`,
		`PLAYER(S) WITH THE MOST CHARGED BATTERIES MAY TAKE PR FROM THE PLAYER ON THEIR LEFT EQUAL TO THE NUMBER OF CHARGED BATTERIES THEY HAVE. IF THAT PLAYER HAD NO PR BEFORE THIS CARD WAS FLIPPED, TAKE ONE (1) BATTERY`,
		`“I CAN SEE YOUR I/O PORT.”`
	),
	createCardNews(
		30,
		`OIL MINED FROM LAST REMAINING WHALE`,
		`EVERY PLAYER TAKES ONE (1) CARBON FROM THE CENTRAL POOL AND PLACES IT INTO THEIR CARBON RESERVE`,
		`“THE WHALE’S LAST WORDS WERE ‘GHUIAAAH.’ PLAYERS MUST REPEAT THEM AS THEY TAKE CARBON`
	),
	createCardNews(
		31,
		`GOVERNMENT REQUIRES ENERGY TO SPRAY CHEMTRAILS`,
		`EACH PLAYER MUST PUT TWO (2) ENERGY INTO THEIR CUP AT THE START OF THIS MONTH`,
		`“I’M PRACTICING MY SKY WRITING.”`
	),
	createCardNews(
		32,
		`“COLD-ISH” DAY IN WORLD’S HOTTEST YEAR RAISES CLIMATE CHANGE DOUBTS`,
		`EACH PLAYER PRODUCES ONE (1) LESS ENERGY THIS MONTH`,
		`“WHAT IF IT’S A HOAX AND WE CREATED A BETTER WORLD FOR NOTHING?”`
	),
	createCardNews(
		33,
		`GREAT PACIFIC GARBAGE PATCH DEEMED STRUCTURALLY SOUND FOR CONSTRUCTION`,
		`PLAYER(S) WITH MOST CONTRACTS IN THEIR COMPLETED PILE MAY BUY FACTORIES HALF OFF (ROUNDED UP) THIS TURN`,
		`“CHRISTENED NEW NEW JERSEY.”`
	),
	createCardNews(
		34,
		`WIKIDRIPS UNCOVERS INSIDER TRADING`,
		`EVERYONE PASSES THEIR HAND TO THE PLAYER TO THEIR LEFT`,
		`“NEWTON’S FIRST LAW IS: YOU DON’T TALK ABOUT...WAIT THAT’S NOT RIGHT.”`
	),
	createCardNews(
		35,
		`SOLAR PANELS INSTALLED ON SURPRISINGLY SUNNY DARK SIDE OF MOON`,
		`FACTORY COST IS REDUCED BY ONE (1) FOR ALL PLAYERS WITH AT LEAST ONE (1) CHARGED BATTERY`,
		`“OH NO, I’M AN ANTI-CONSPIRACY THEORIST. I THINK THE MOON LANDING WAS A COVER UP FOR KUBRICK FILMING HIS MOVIES UP THERE.”`
	),
	createCardNews(
		36,
		`ANCIENT ALIEN TECHNOLOGY FOUND`,
		`PLAYER(S) WITH THE FEWEST BATTERIES MAY BUY BATTERIES FOR ONE (1) ENERGY THIS MONTH`,
		`"ALIENS.”`
	),
	createCardNews(
		37,
		`NET METERING LEGALIZED NATIONWIDE`,
		`PLAYER(S) WITH THE HIGHEST CARBON FOOTPRINT LOSE ONE (1) FACTORY`,
		`“WHY WASTE A GOOD AMPERE?”`
	),
	createCardNews(
		38,
		`ANIMATED MOVIE, “FINDING NUCLEUS” WINS OVER PUBLIC’S HEART`,
		`PLAYER(S) WITH THE LARGEST CARBON FOOTPRINT’S FACTORIES DO NOT PRODUCE ENERGY THIS TURN INSTEAD, THE PLAYER(S) RECHARGE ALL OF THEIR BATTERIES`,
		`“JUST KEEP SPLITTING, JUST KEEP SPLITTING.”`
	),
	createCardNews(
		39,
		`PRESIDENTIAL HOPEFUL CONFIRMED TO BE ZODIAC KILLER`,
		`PLAYER(S) WITH THE HIGHEST CARBON FOOTPRINT LOSES ALL OF THEIR PR IF THEIR PR WAS ALREADY AT ZERO THEY LOSE A FACTORY **ONE PLAYER MUST HAVE A CARBON FOOTPRINT OF AT LEAST ONE (1)**`,
		`“I’M VOTING FOR HIM PURELY ON POLICY.”`
	),
];
